import { Map } from 'immutable';
import { endsWith } from 'common/functions/string';

export class Serializer {
    constructor(public typeRegistry: Map<string, typeof Object>) {
    }

    createFromRegistry(typeName: string) {
        const type = this.typeRegistry.get(typeName);
        try {
            return new type();
        } catch (e) {
            throw new Error(`Could not resolve type ${typeName}`);
        }
    }

    read(data: any) {
        if (data.$type === undefined)
            return data;
        else {
            const type = data.$type;

            if (type === 'System.Byte[]')
                return data.$value;

            if (endsWith(type, '[]')) {
                const a: any = [];
                for (let i = 0; i < data.$values.length; i++) {
                    a.push(this.read(data.$values[i]));
                }
                return a;
            } else {
                const n = this.createFromRegistry(type);
                this.stitchProperties(data, n);
                return n;
            }
        }
    }

    private stitchProperties(source: any, destination: any) {
        for (let prop in source) {
            if (source.hasOwnProperty(prop)/* && destination.hasOwnProperty(prop)*/) {
                if (prop !== '$type') {
                    if (source[prop] == null) {
                        destination[prop] = null;
                    } else if (Array.isArray(source[prop].$values)) {
                        destination[prop] = [];
                        for (let i = 0; i < source[prop].$values.length; i++) {
                            destination[prop].push(this.read(source[prop].$values[i]));
                        }
                    } else if (source[prop].$type === undefined) {
                        destination[prop] = source[prop];
                    } else {
                        destination[prop] = this.read(source[prop]);
                    }
                }
            }
        }
    }
}